

export const veoHowto = {
    title: '如何生成電影級 AI 影片',
    subtitle: '三步完成：使用關鍵幀、多張參考圖與原生音訊，生成高品質影片。',
    steps: [
      { num: '1', title: '建立專案：關鍵幀或參考圖', body: '輸入詳細提示或上傳圖片。使用關鍵幀控制起始/結尾，或以多圖維持風格一致。' },
      { num: '2', title: '設定進階參數', body: '開啟關鍵幀、加入參考圖、設定比例、升級 1080P。原生音訊提供同步音效。' },
      { num: '3', title: '生成、延長與下載', body: '生成含原生音訊的影片；使用延長功能超越 8 秒。預覽並下載喜好的品質。' }
    ],
  };
